import { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Switch, Route, useLocation, useRouteMatch } from 'react-router-dom';

import ViewTitle from '../../common/view-title';
import Loader from '../../common/loader';
import NotFound from '../../common/not-found';

import PolicyIndex from './policy-index';
import PolicyCreate from './policy-create';
import PolicyDetail from './policy-detail';
import PolicyEdit from './policy-edit';

import helpers from '../../utils/helpers';

const useStyles = makeStyles(() => ({
    root: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column'
    }
}));

const PolicyRoutes = () => {

    const classes = useStyles();
    const { pathname } = useLocation();
    const { path } = useRouteMatch();
    const [state, setState] = useState({
        loading: true,
        permissions: {}
    });

    useEffect(() => {
        const validatePermissions = () => {
            const permissions = helpers.getPermissions(pathname);
            setState(prev => ({ ...prev, permissions, loading: false }));
        }

        validatePermissions();
    }, []);

    if (state.loading) return <Loader />;
    if (!state.permissions?.read_attr) return <NotFound />;

    return (
        <div className={classes.root}>
            <ViewTitle title='Policies' />

            <Switch>
                <Route exact strict path={path}><PolicyIndex permissions={state.permissions} /></Route>
                <Route exact strict path={`${path}/create`}><PolicyCreate permissions={state.permissions} /></Route>
                <Route exact strict path={`${path}/detail/:id`}><PolicyDetail permissions={state.permissions} /></Route>
                <Route exact strict path={`${path}/detail/:id/edit`}><PolicyEdit permissions={state.permissions} /></Route>
                <Route path={`${path}/*`}><NotFound /></Route>
            </Switch>
        </div>
    );
}

export default PolicyRoutes;